export const DUMMY_WIDGET = Promise.resolve({ default: () => <div>Dummy</div> });
